export enum STATUS_LEVEL_COLUMN {
  POSITION = 'position',
  NAME = 'name',
  SUBLEVELS = 'subLevels',
}
